export const membershipForm = (() => {
    const form = document.querySelector('[data-membership-form]');

    if (!form) return;

    const submitButton = form.querySelector('[data-membership-recaptcha]');

    if (!submitButton) return;

    const orgNoInput = form.querySelector('#organizationNumber');
    const emailInput = form.querySelector('#email');
    const tokenInput = form.querySelector('#token');
    const apiErrorDiv = document.getElementById('api-error');
    const apiErrorMessage = document.getElementById('api-error-message');
    const apiSuccessDiv = document.getElementById('api-success');
    const orgNoErrorDiv = document.getElementById('orgno-validation-error');
    const emailErrorDiv = document.getElementById('email-validation-error');
    const thankyouUrl = submitButton.getAttribute('data-thankyou-url');

    let isSubmitting = false;

    const orgNoRegex = /^\d{6}-?\d{4}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    orgNoInput.addEventListener('input', validateForm);
    orgNoInput.addEventListener('change', validateForm);
    emailInput.addEventListener('input', validateForm);
    emailInput.addEventListener('change', validateForm);

    validateForm();

    if (submitButton) {
        submitButton.addEventListener('click', function (event) {
            event.preventDefault();

            if (isSubmitting) return;

            if (!form.checkValidity()) {
                form.reportValidity();
                return;
            }

            hideMessages();

            // Check if reCAPTCHA is available (production) or if we're in development mode
            if (typeof grecaptcha !== 'undefined') {
                const sitekey = submitButton.getAttribute('data-sitekey');

                grecaptcha.ready(function () {
                    grecaptcha.execute(sitekey, { action: 'submit' }).then(function (token) {
                        tokenInput.value = token;
                        submitMembershipApplication();
                    });
                });
            } else {
                // Development mode - submit directly without reCAPTCHA token
                tokenInput.value = 'dev-bypass-token';
                submitMembershipApplication();
            }
        });
    }

    function submitMembershipApplication() {
        isSubmitting = true;
        submitButton.disabled = true;

        const antiForgeryToken = form.querySelector('input[name="__RequestVerificationToken"]').value;

        const data = {
            OrganizationNumber: orgNoInput.value.trim(),
            Email: emailInput.value.trim(),
            Token: tokenInput.value
        };

        fetch('/Membership/apply', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'RequestVerificationToken': antiForgeryToken
            },
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                return response.text().then(errorText => {
                    throw new Error(errorText);
                });
            }
            return response;
        })
        .then(() => {
            showSuccess();

            if (thankyouUrl && thankyouUrl !== '') {
                setTimeout(() => {
                    window.location.href = thankyouUrl;
                }, 1500);
            }

            if (window.dataLayer) {
                window.dataLayer.push({ 'event': 'form_submit' });
            }
        })
        .catch(error => {
            const errorType = error.message;
            showError(errorType);
        })
        .finally(() => {
            setTimeout(() => {
                isSubmitting = false;
                submitButton.disabled = false;
            }, 3000);
        });
    }

    function showError(errorType) {
        let errorMessage = 'Ett oväntat fel uppstod. Vänligen försök igen.';

        if (errorType.includes('MembershipAlreadyExiststException')) {
            errorMessage = 'Det finns redan en ansökan för detta organisationsnummer.';
        } else if (errorType.includes('MembershipInvalidRequestException')) {
            errorMessage = 'Ogiltig förfrågan. Kontrollera att organisationsnumret är korrekt.';
        } else if (errorType.includes('MembershipErpException')) {
            errorMessage = 'Ett fel uppstod i vårt system. Vänligen försök igen senare.';
        } else if (errorType.includes('MembershipApplicationException')) {
            errorMessage = 'Ett fel uppstod vid skapande av ansökan. Vänligen försök igen.';
        } else if (errorType.includes('MembershipUnknowedException')) {
            errorMessage = 'Ett okänt fel uppstod. Vänligen kontakta oss direkt.';
        }

        apiErrorMessage.textContent = errorMessage;
        apiErrorDiv.style.display = 'block';
    }

    function showSuccess() {
        apiSuccessDiv.style.display = 'block';
    }

    function hideMessages() {
        apiErrorDiv.style.display = 'none';
        apiSuccessDiv.style.display = 'none';
    }

    function validateForm() {
        let isValid = true;
        const orgNoValue = orgNoInput.value.trim();
        const emailValue = emailInput.value.trim();
        const isOrgNoActive = orgNoInput === document.activeElement;
        const isEmailActive = emailInput === document.activeElement;

        if (orgNoValue === '') {
            isValid = false;
        } else if (!orgNoRegex.test(orgNoValue)) {
            isValid = false;
            if (!isOrgNoActive && orgNoErrorDiv) {
                orgNoErrorDiv.style.display = 'block';
            } else if (orgNoErrorDiv) {
                orgNoErrorDiv.style.display = 'none';
            }
        } else if (orgNoErrorDiv) {
            orgNoErrorDiv.style.display = 'none';
        }

        if (emailValue === '') {
            isValid = false;
        } else if (!emailRegex.test(emailValue)) {
            isValid = false;
            if (!isEmailActive && emailErrorDiv) {
                emailErrorDiv.style.display = 'block';
            } else if (emailErrorDiv) {
                emailErrorDiv.style.display = 'none';
            }
        } else if (emailErrorDiv) {
            emailErrorDiv.style.display = 'none';
        }

        if (submitButton && isValid) {
            submitButton.classList.remove('btn--disabled');
        } else if (submitButton && !isValid) {
            submitButton.classList.add('btn--disabled');
        }
    }

})();
